import {SALPrinterActions} from "../actions/SALPrinterActions";
import {ChangePrinterResponse} from "./ChangePrinterResponse";
import {updateAlert} from "../../utils/utils";

export function onChangePrinterResponse(moduleInitializationParams, props, setAlert, resetNavCol, dispatchPrinter) {
    const change_printer_response = JSON.parse(moduleInitializationParams.change_printer_response);
    if (change_printer_response.success) {
        dispatchPrinter({type: SALPrinterActions.CHANGE_PRINTER_SUCCESS});
        props.history.goBack();
    }
    else if (change_printer_response.message) {
        switch (change_printer_response.message) {
            case ChangePrinterResponse.CONNECTION_FAILED_PRINTER_OFF:
                updateAlert(setAlert, resetNavCol, null, "warning", props.intl.formatMessage(
                    {id: "printer.connection_failed_printer_off"}
                ));
                break;
            case ChangePrinterResponse.CONNECTION_FAILED_UNPAIRED_DEVICE:
                updateAlert(setAlert, resetNavCol, null, "warning", props.intl.formatMessage(
                    {id: "printer.connection_failed_unpaired_device"}
                ));
                break;
            case ChangePrinterResponse.CONNECTION_FAILED:
                updateAlert(setAlert, resetNavCol, null, "warning", props.intl.formatMessage(
                    {id: "printer.connection_failed"}
                ));
                break;
            default:
                updateAlert(setAlert, resetNavCol, null, "warning", change_printer_response.message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/scanPrinter/utils/utils.js